module.exports = __webpack_public_path__ + "1_0_65/img/Taj Mahal.14810486.jpg";